import { render, staticRenderFns } from "./SendPasswordCreateMailAction.vue?vue&type=template&id=808c75d0&scoped=true&"
import script from "./SendPasswordCreateMailAction.vue?vue&type=script&lang=ts&"
export * from "./SendPasswordCreateMailAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808c75d0",
  null
  
)

export default component.exports